import ZskkLogController from './log'
import {} from './clearlog'
const ZskkController = {ZskkLogController}
export default ZskkController